import { Component, OnInit } from '@angular/core';
import { CreateStoreComponent } from '../create-store/create-store.component';
import { StoreService } from '../../services/store.service';
import { LoaderService } from '@app/core/services/loader/loader.service';
import { NotificationService } from '@app/core/services/notification/notification.service';
import { DomSanitizer } from '@angular/platform-browser';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ErrorhandlerService } from '@app/shared/services/errorhandler/errorhandler.service';
import {EditStoreShopifyPopupComponent} from '@app/feature/store-admin/components/edit-store-shopify-popup/edit-store-shopify-popup.component';
import {PopupSelectStoreComponent} from '@app/feature/store-admin/components/popup-select-store/popup-select-store.component';
import {ActivatedRoute} from '@angular/router';
import {HandleApiService} from '@app/core/services/handleApi/handle-api.service';
import {map} from 'rxjs/operators';
import {GetStoreListInterface} from '@app/feature/store-admin/services/GetStoreList.interface';
@Component({
  selector: 'app-store-list',
  templateUrl: './store-list.component.html',
  styleUrls: ['./store-list.component.css']
})
export class StoreListComponent implements OnInit {

    storeList: any[] = [];
    // For Infinite scroll of grid
    pageSize = 10; // No of items to load from server side i.e no of items to take
    initialItemsCount !: number;  // No of items to skip
    throttle = 50;
    searchString: any;
    // --------------------------

    ApplicationUserId !: any;
    searchStoreForm !: FormGroup;
    companyId: any;
  constructor(public dialog: MatDialog,
              public storeService: StoreService,
              private loaderService: LoaderService,
              private notificationService: NotificationService,
              private domSanitizer: DomSanitizer,
              private formBuilder: FormBuilder,
              private errorhandlerService: ErrorhandlerService,
              private activatedRoute: ActivatedRoute,
              private handleApi: HandleApiService) {
    this.searchStoreForm = this.formBuilder.group({
      searchStore: ['']
    });
  }

  ngOnInit() {
    this.storeList = [];
    this.initialItemsCount = 0;
    this.ApplicationUserId = localStorage.getItem('userId');
    this.companyId = parseInt(localStorage.getItem('companyId'));
    this.fn_getStoreList();
  }
  shouldItOpenWindowSelectStoreForInstallingKey(storeList: GetStoreListInterface[]) {

    this.activatedRoute.queryParams.subscribe(params => {
      if (params['apikey'] && !this.checkIfApiKeyShopifyInstalled(storeList, params['apikey'] )) {
       
         this.dialog.open(PopupSelectStoreComponent);
      }
    });
  }

  checkIfApiKeyShopifyInstalled(storeList: GetStoreListInterface[], apiKey: string) {
    const result = storeList.find((x: GetStoreListInterface) => x.apikey === apiKey);
    return !!result;
  }

  /** Opens create store dialog */
  createStore(): void {
    const dialogRef1 = this.dialog.open(CreateStoreComponent);

    dialogRef1.afterClosed().subscribe(() => {
      this.fn_getStoreList();
    });
  }
  /** Search store by name */
  fn_searchStore(form: FormGroup) {
    this.storeList = [];
    this.initialItemsCount = 0;
    this.searchString = form.controls['searchStore'].value;
    this.fn_getStoreList();
  }

  /** Function to get store list */
  fn_getStoreList() {
    this.initialItemsCount === 0 ? this.loaderService.show() : this.loaderService.lazyLoaderShow();
    this.storeService.getStoreList(
      this.fn_CheckForNullUndefinedEmptyString(this.searchString),
      this.initialItemsCount,
      this.pageSize,
      true,
      this.ApplicationUserId, true)
      .pipe(map(this.handleApi.handleApi('Store'))).subscribe((res) => {
      if (res.StatusCode === 200) {
        this.shouldItOpenWindowSelectStoreForInstallingKey(res.Data.ResponseData);
        this.fn_AddLazyLoadedItems(res.Data.ResponseData);
      }
      this.loaderService.lazyLoaderHide() ;
    }, (err: any) => {
      this.loaderService.hide();
      this.loaderService.lazyLoaderHide() ;
      this.errorhandlerService.handleError(err);
    });
  }

  /** Function to add new lazy loaded items to original items list */
  fn_AddLazyLoadedItems (items: any) {
     if (items !== null && items.length !== 0) {
        for (let i = 0; i < items.length; i++) {
          if (items[i].StoreSetting !== null) {
            items[i].StoreSetting.StoreImageBanner = items[i].StoreSetting.StoreImageBanner == null ? 'http://placehold.it/180' :
            this.domSanitizer.bypassSecurityTrustUrl(items[i].StoreSetting.StoreImageBanner);
          }
          if (!this.storeList.find(x => x.StoreId === items[i].StoreId)) {
            this.initialItemsCount = this.storeList.push(items[i]);
          }
        }
    }
  }

  fn_CheckForNullUndefinedEmptyString(value: any) {
    if (value === null || value === '' || value === undefined) {
      return '';
    } else {
      return value;
    }
  }
}
